import axios from "axios";

/* In the browser we always call the API same-origin (both the emergent.host
   and custom production domains route /api to the same backend). The env URL
   is only needed for local development on a different port. */
const envUrl = process.env.REACT_APP_BACKEND_URL;
const isLocalhost =
  typeof window !== "undefined" &&
  /^https?:\/\/(localhost|127\.0\.0\.1)/.test(window.location.origin);
const BACKEND_URL =
  typeof window === "undefined" || isLocalhost ? envUrl : window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
